import { useNavigate } from 'react-router-dom'

import BettingVendorAccountTemplate from '@/components/templates/bettingVendorAccount/bettingVendorAccountTemplate'

export default function BettingVendorAccountPage() {
    const navigate = useNavigate()

    return <BettingVendorAccountTemplate navigate={navigate} />
}
